export default variables => ({
  ...variables,
  colorBackground: variables.colorDarkGrey,
  colorBackgroundShade: variables.colorMediumLighterGrey,
});
